export var getUserInitials = function (user) {
    if (user.firstName && user.lastName) {
        return "" + user.firstName[0] + user.lastName[0];
    }
    if (user.firstName) {
        return user.firstName[0];
    }
    var splitedEmail = user.email.slice(0, user.email.indexOf('@')).split(/[_\-\.]{1,}/);
    if (splitedEmail.length >= 2) {
        return "" + splitedEmail[0][0] + splitedEmail[1][0];
    }
    return splitedEmail[0][0];
};
//# sourceMappingURL=getUserInitials.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/header-microfrontend/dist/components/UserBlock/components/UserAvatar/getUserInitials.js
// module id = 1369
// module chunks = 118